import { gql } from '@apollo/client';

export const GET_FETCH_SPONSOR_DETAILS_INFO = gql`
  query MyQuery($slug: String!) {
    fetchSponsorDetails(slug: $slug) {
      adultOnly
      category
      created
      description
      discussionCount
      featured
      featuredEnd
      featuredStart
      id
      joinedCommunity
      likeCount
      liked
      loggedInUserId
      modified
      name
      terms
      personCount
      premium
      slug
      summary
      website
      memberSince
      stats {
        reviewCount
        discussionCount
        imageCount
        videoCount
        participantCount
      }
      heroPlayList {
        autoPlay
        id
        mediaUrl
        asset {
          assetType
          basename
          checksum
          conversionStatusBits
          description
          hlsPlaylistUrl
          id
          isExternal
          mimeType
          mp4Url
          provider
          providerId
          sharedURL
          thumbNailUrl
          webmUrl
        }
      }
    }
  }
`;

export const GET_FETCH_PRODUCTS_DETAILS_INFO = gql`
  query MyQuery($slug: String!) {
    fetchProductDetails(slug: $slug) {
      adminAssetId
      adminName
      adminNotes
      category
      adultOnly
      created
      description
      discussionCount
      eventId
      featuredEnd
      featuredStart
      sponsorSlug
      sponsorId
      sponsorName
      id
      joinedCommunity
      likeCount
      liked
      loggedInUserId
      modified
      name
      order
      personCount
      reviiewUrl
      sku
      slug
      summary
      syndicationType
      isReviewable
      totalRatingEntries
      ratingAvg
      commentCount
      reviewCount
      heroPlayList {
        autoPlay
        id
        mediaUrl
        asset {
          assetType
          basename
          checksum
          conversionStatusBits
          description
          hlsPlaylistUrl
          id
          isExternal
          mimeType
          mp4Url
          provider
          providerId
          sharedURL
          thumbNailUrl
          webmUrl
        }
      }
    }
  }
`;

export const GET_EVENT_SEARCH = gql`
  query MyQuery($pageNo: Int!, $pageSize: Int!, $sponsorSlug: String!) {
    fetchSponsorDetails(slug: $sponsorSlug) {
      adultOnly
      category
      terms
      created
      description
      discussionCount
      featured
      featuredEnd
      featuredStart
      id
      joinedCommunity
      likeCount
      liked
      loggedInUserId
      modified
      name
      personCount
      premium
      slug
      summary
      website
      memberSince
      stats {
        reviewCount
        discussionCount
        imageCount
        videoCount
        participantCount
      }
      heroPlayList {
        autoPlay
        id
        mediaUrl
        asset {
          assetType
          basename
          checksum
          conversionStatusBits
          description
          hlsPlaylistUrl
          id
          isExternal
          mimeType
          mp4Url
          provider
          providerId
          sharedURL
          thumbNailUrl
          webmUrl
        }
      }
    }

    getSponsorEvents(
      pageNo: $pageNo
      pageSize: $pageSize
      sponsorSlug: $sponsorSlug
    ) {
      total
      data {
        aampp
        adultOnly
        active
        bannerUrl
        created
        customVariables
        deleted
        description
        heroPlayList {
          autoPlay
          expires
          mediaUrl
          id
          mobileHero
          published
          assets {
            assetId
            basename
            description
            hlsPlaylistUrl
            mimeType
            mp4Url
            thumbnailUrl
            webmUrl
            url
            type
          }
        }
        community {
          id
          name
        }
        categories {
          id
          name
        }
        eventType
        displayLimit
        name
        languageId
        id
        likeCount
        liked
        listed
        modified
        ongoing
        sendSelectionNotification
        slug
        sponsorId
        summary
        template
        virtual
        website
        featured
        featuredEnd
        featuredStart
        forceAddressVerification
        forceChildrenVerification
        discussionCount
        discoverable
      }
    }
  }
`;

export const GET_PRODUCT_SEARCH = gql`
  query MyQuery($pageNo: Int!, $pageSize: Int!, $sponsorSlug: String!) {
    fetchSponsorDetails(slug: $sponsorSlug) {
      adultOnly
      category
      created
      terms
      description
      discussionCount
      featured
      featuredEnd
      featuredStart
      id
      joinedCommunity
      likeCount
      liked
      loggedInUserId
      modified
      name
      personCount
      premium
      slug
      summary
      website
      memberSince
      stats {
        reviewCount
        discussionCount
        imageCount
        videoCount
        participantCount
      }
      heroPlayList {
        autoPlay
        id
        mediaUrl
        asset {
          assetType
          basename
          checksum
          conversionStatusBits
          description
          hlsPlaylistUrl
          id
          isExternal
          mimeType
          mp4Url
          provider
          providerId
          sharedURL
          thumbNailUrl
          webmUrl
        }
      }
    }

    getProductsByCategory(
      pageNo: $pageNo
      pageSize: $pageSize
      sponsorSlug: $sponsorSlug
    ) {
      totalCount
      data {
        adminName
        created
        description
        discussionCount
        id
        likeCount
        liked
        name
        reviewCount
        reviewUrl
        slug
        summary
        heroPlayList {
          autoPlay
          expires
          id
          mediaUrl
          mobileHero
          published
          assets {
            assetId
            basename
            description
            hlsPlaylistUrl
            mimeType
            mp4Url
            thumbnailUrl
            type
            url
            webmUrl
          }
        }
      }
    }
  }
`;
